module.exports = __webpack_public_path__ + "app/modals/duplicate-device-ip-modal.view.html";